<template>
    <div class="alert alert-warning mb-6 text-sm">
        <p>&bull; To enter a link to text select the text you want to add the link to.</p>
        <p>&bull; Drag and drop images where you would like them placed.</p>
    </div>

    <div class="w-full mb-4">
        <label for="" class="py-1">Content</label>
        <w-editor class="pt-2 border-t" :content="form.body" v-model="form.body"></w-editor>
    </div>

    <div class="w-full mb-4">
        <label for="link">Learn More Link URL</label>
        <input class="form-input form-input-sm" type="text" name="link" v-model="form.link" />
    </div>

    <div class="w-full mt-8">
        <button class="btn btn-yellow" @click="handleUpdate">Update</button>
        <a href="/admin" class="text-black ml-2 btn btn-default">Cancel</a>
    </div>

    <flash-message ref="flash"></flash-message>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    initial: Object
});

const flash = ref(null);

const form = ref({
    body: props.initial.body || null,
    link: props.initial.link || ''
});

function handleUpdate() {
    const route = window.route('admin.homepage.update');
    axios.post(route, form.value)
        .then((response) => {
            flash.value.display('Updated Homepage!')
        }).catch(error => {
            flash.value.error('Error updating homepage')
        });
}
</script>
